var map = {
	"./box-checkmark.svg": "7f68",
	"./box-open.svg": "4126",
	"./box-questionmark.svg": "f1eb",
	"./box-stacked.svg": "3d75",
	"./couriers/courier-abffreight.svg": "8725",
	"./couriers/courier-aduiepyle.svg": "622c",
	"./couriers/courier-canadapost.svg": "1472",
	"./couriers/courier-canpar.svg": "2a19",
	"./couriers/courier-centraltransport.svg": "c616",
	"./couriers/courier-dayross.svg": "c042",
	"./couriers/courier-default.svg": "6310",
	"./couriers/courier-dhl.svg": "6e20",
	"./couriers/courier-estesexpress.svg": "9a54",
	"./couriers/courier-fastfrate.svg": "954e",
	"./couriers/courier-fedex.svg": "5e5c",
	"./couriers/courier-forwardair.svg": "b4c1",
	"./couriers/courier-gls.svg": "c773",
	"./couriers/courier-ics.svg": "e2dc",
	"./couriers/courier-jpexpress.svg": "8523",
	"./couriers/courier-loomis.svg": "6688",
	"./couriers/courier-maritimeontario.svg": "9040",
	"./couriers/courier-olddominion.svg": "6a0a",
	"./couriers/courier-ptc.svg": "6736",
	"./couriers/courier-purolator.svg": "2978",
	"./couriers/courier-purolatorfreight.svg": "d606",
	"./couriers/courier-rlcarriers.svg": "d920",
	"./couriers/courier-saia.svg": "443d",
	"./couriers/courier-tforcefreight.svg": "c782",
	"./couriers/courier-totalship.svg": "8cd5",
	"./couriers/courier-trexity.svg": "01ba",
	"./couriers/courier-truxweb.svg": "d288",
	"./couriers/courier-tsl.svg": "0ae7",
	"./couriers/courier-ups.svg": "27da",
	"./couriers/courier-usps.svg": "503b",
	"./couriers/courier-wardtrucking.svg": "10e5",
	"./couriers/courier-warp.svg": "4c59",
	"./couriers/courier-xpologistics.svg": "2257",
	"./couriers/fedex-logo-official.svg": "b74d",
	"./creditCardTypes/AmericanExpress.svg": "0e4f",
	"./creditCardTypes/MasterCard.svg": "247d",
	"./creditCardTypes/Visa.svg": "8b6e",
	"./curved-line.svg": "820d",
	"./delivery-guy.svg": "f8a0",
	"./electronic-trade-documents/pin-icon-active.svg": "ad8d",
	"./electronic-trade-documents/pin-icon.svg": "cf08",
	"./electronic-trade-documents/sort-icon.svg": "22b7",
	"./electronic-trade-documents/upload-icon.svg": "b3bb",
	"./empty-address-book.svg": "0adb",
	"./gurus/birthday.svg": "1045",
	"./gurus/black-friday.svg": "db04",
	"./gurus/cyber-monday.svg": "eafa",
	"./gurus/default.svg": "8021",
	"./history-map-placeholder.svg": "4a99",
	"./icons/SSL-Logo.svg": "577f",
	"./icons/icon-arrow-down-dark.svg": "67d8",
	"./icons/icon-arrow-down.svg": "ab4a",
	"./icons/icon-arrow-left.svg": "a7ae",
	"./icons/icon-arrow-right.svg": "47b8",
	"./icons/icon-arrow-up.svg": "ff5e",
	"./icons/icon-box.svg": "a8ca",
	"./icons/icon-chevron-up.svg": "2b56",
	"./icons/icon-credit-card.svg": "4ead",
	"./icons/icon-cross.svg": "32e2",
	"./icons/icon-dropdown-arrow.svg": "d358",
	"./icons/icon-envelope.svg": "f2cb",
	"./icons/icon-eye-hide.svg": "6f1b",
	"./icons/icon-eye-show.svg": "3229",
	"./icons/icon-info-circle.svg": "d5db",
	"./icons/icon-pickup-cost-blue.svg": "e4ac",
	"./icons/icon-pickup-cost-gray.svg": "bd7d",
	"./icons/icon-pickup-cost-yellow.svg": "770d",
	"./icons/icon-pickup-cost.svg": "f7a7",
	"./icons/icon-plus.svg": "6bc6",
	"./icons/icon-questionmark.svg": "e836",
	"./icons/icon-save-to-book.svg": "309d",
	"./icons/icon-search.svg": "6a1a",
	"./icons/icon-secure-payment-ssl.svg": "596d",
	"./icons/icon-secure-payment.svg": "bc6d",
	"./icons/icon-step-1.svg": "5dcb",
	"./icons/icon-step-2.svg": "6197",
	"./icons/icon-step-3.svg": "870d",
	"./icons/icon-step-4.svg": "bcfa",
	"./icons/icon-step-5.svg": "a030",
	"./icons/icon-truck.svg": "a10d",
	"./icons/icon-use-secureship-blue.svg": "be96",
	"./icons/icon-use-secureship-gray.svg": "9034",
	"./icons/icon-use-secureship-yellow.svg": "fe36",
	"./icons/icon-use-secureship.svg": "8338",
	"./icons/stars-illustration.svg": "43ca",
	"./icons/verified.svg": "5df3",
	"./logo-canada-mapple-only-light.svg": "8ab1",
	"./logo-canada-mapple-only.svg": "e0a4",
	"./logo-canada-with-flag-light.svg": "19f7",
	"./logo-canada-with-flag.svg": "de97",
	"./logo-light.svg": "e91d",
	"./logo-mini.svg": "0df4",
	"./logo.svg": "e347",
	"./mascot-captain.svg": "3a38",
	"./mascot-juggling.svg": "85d1",
	"./mascot-login.svg": "05be",
	"./mascot-logout.svg": "b645",
	"./mascot-more-info.svg": "ba53",
	"./mascot-no-content.svg": "7032",
	"./mascot-no-permission.svg": "715d",
	"./mascot-query-string.svg": "1dd2",
	"./mascot-schedule-pickup.svg": "258b",
	"./mascot-terms.svg": "8ad7",
	"./mascot-welcome.svg": "9bd4",
	"./mascots/mascot-change-pass.svg": "4b9c",
	"./mascots/mascot-print-page.svg": "c56f",
	"./mascots/no-results.svg": "243b",
	"./notifications/AdultSignatureNA.svg": "2388",
	"./notifications/B13a.svg": "c8ee",
	"./notifications/Battery.svg": "0b07",
	"./notifications/CPCPickup.svg": "5f10",
	"./notifications/CarrierEnv.svg": "960f",
	"./notifications/CarrierPak.svg": "0f7a",
	"./notifications/CurrencyPriceChange.svg": "bb45",
	"./notifications/DangerousGoods.svg": "38d7",
	"./notifications/DeliveryTimeInfo.svg": "cb96",
	"./notifications/DimensionsMissing.svg": "7262",
	"./notifications/FreightMultiPackagesWarning.svg": "ee72",
	"./notifications/FreightRequirements.svg": "134e",
	"./notifications/GLSNoPickupFee.svg": "5d71",
	"./notifications/InsuranceLimitations.svg": "6869",
	"./notifications/IsCallRequested.svg": "1b19",
	"./notifications/IsFragile.svg": "61cf",
	"./notifications/IsPickupComments.svg": "b57b",
	"./notifications/IsSignatureRequested.svg": "b33a",
	"./notifications/MerchantRedirectCPC.svg": "51e4",
	"./notifications/MerchantRedirectUPS.svg": "20e5",
	"./notifications/MinimumPackaging.svg": "efcb",
	"./notifications/NextDayPickup.svg": "7ffc",
	"./notifications/NoInsuranceWhenCustomsValueDeclared.svg": "24b1",
	"./notifications/POBox.svg": "e558",
	"./notifications/Perfume.svg": "4878",
	"./notifications/PersonalEffects.svg": "bd67",
	"./notifications/PickupNotMonitored.svg": "135d",
	"./notifications/ResidentialPickup.svg": "0e5f0",
	"./notifications/RiskOfLargePackage.svg": "376c",
	"./notifications/RiskOfOverLimit.svg": "695e",
	"./notifications/ScheduleCanparPickup.svg": "5e56",
	"./notifications/SchedulePickup.svg": "42ee",
	"./notifications/expressFreightShipment.svg": "c0ba",
	"./notifications/notification-oops.svg": "ab5d",
	"./notifications/theresACheaperOption.svg": "ebf7",
	"./schedule/cancel-pickup.svg": "2985",
	"./schedule/no-pickup.svg": "c937",
	"./schedule/no-results.svg": "f713",
	"./schedule/pickup-confirmation-cancel.svg": "d9da",
	"./schedule/pickup-confirmation.svg": "7faa",
	"./schedule/pickup-summary.svg": "8e9f",
	"./shipping-tips/country-rules.svg": "d575",
	"./shipping-tips/how-to-customize.svg": "7bc0",
	"./shipping-tips/learning-center.svg": "e880",
	"./shipping-tips/ship-for-success.svg": "8192",
	"./stepcounter-checkmark.svg": "8e5e",
	"./stepcounter-truck.svg": "02df",
	"./stores/store-amazon.svg": "d777",
	"./stores/store-aspdotnetstorefront.svg": "f78a",
	"./stores/store-bigcommerce.svg": "fdb0",
	"./stores/store-commercehq.svg": "5ef2",
	"./stores/store-demandware.svg": "07c0",
	"./stores/store-ebay.svg": "a660",
	"./stores/store-ecwid.svg": "c21f",
	"./stores/store-etsy.svg": "8bc3",
	"./stores/store-hybris.svg": "a062",
	"./stores/store-lightspeed.svg": "e0fa",
	"./stores/store-mssql.svg": "bab0",
	"./stores/store-neto.svg": "f2c0",
	"./stores/store-restapi.svg": "9b9a",
	"./stores/store-shopify.svg": "ab4b",
	"./stores/store-shopware.svg": "593c",
	"./stores/store-sqlserver.svg": "0e16",
	"./stores/store-squarespace.svg": "9eb7",
	"./stores/store-threedcart.svg": "78fd",
	"./stores/store-volusion.svg": "4dd4",
	"./stores/store-walmart.svg": "6081",
	"./stores/store-woocommerce.svg": "6e94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";